import React from 'react';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../../tc-ui/two-column-row.jsx';
import Icon from '../../../../tc-ui/icon';
import { insert, remove } from 'ramda';

const PrivateToursTransfersPriceBreak = ({ updateFieldWithKeyPath, nonStandardTemplateType, ...fieldValues }) => {
  const fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  const leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px', fontFamily };
  const rightColumnStyle = { width: '70%', textAlign: 'left', fontFamily };
  return (
    <div>
      <TwoColumnRow
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflow: 'inherit', clear: 'both', height: '24px', marginBottom: '0', marginTop: '12px' }}
        rightColumnContent={
        <div>
        <div style={{ width: '10%', display: 'inline-block' }}></div>
        <div style={{ width: '18%', display: 'inline-block', marginLeft: '2%' }}>Guests</div>
        <div style={{ width: '20%', display: fieldValues.rateType === 'includeCommission' ? 'inline-block' : 'none', marginLeft: '2%' }}>Retail</div>
        <div style={{ width: '20%', display: 'inline-block', marginLeft: '2%' }}>Nett</div>
        </div>
        }
      />
      <TwoColumnRow
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflow: 'inherit', clear: 'both', height: '42px', marginBottom: '0' }}
        leftColumnContent={<div style={{ position: 'relative', top: '14px' }}>
            Base rates information
          <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
            * At least one rate detail is required
          </div>
        </div>}
        rightColumnContent={
          fieldValues.transfersOrPriceBreak.map((transfer, index) => (<div key={index}>
            <div style={{ width: '10%', display: 'inline-block' }}>
              Up to
            </div>
            <TypeControlledTextField
              id="maxAdultsPlusChild"
              style={{ width: '20%' }}
              value={transfer.maxAdultsPlusChild}
              onChange={({ target: { value } }) => updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'maxAdultsPlusChild'], value })}
            />
            {
             fieldValues.rateType === 'includeCommission' ?
             <TypeControlledTextField
               id="retailRate"
               style={{ width: '20%', marginLeft: '2%' }}
               hintText="Total cost"
               hintStyle={{ fontSize: '14px' }}
               value={transfer.retailRate}
               onChange={({ target: { value } }) => updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'retailRate'], value })}
             /> : undefined
            }
            <TypeControlledTextField
              id="baseRate"
              style={{ width: '20%', marginLeft: '2%' }}
              disabled={fieldValues.rateType === 'includeCommission'}
              hintText="Total cost"
              hintStyle={{ fontSize: '14px' }}
              value={transfer.baseRate}
              onChange={({ target: { value } }) => updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'baseRate'], value })}
            />
            <Icon
              className="tc-icon-close"
              style={{
                marginLeft: '16px',
                lineHeight: '24px',
                verticalAlign: 'middle',
                color: fieldValues.transfersOrPriceBreak.length > 1 ? '#ff4081' : 'grey',
                cursor: fieldValues.transfersOrPriceBreak.length > 1 ? 'pointer' : 'normal',
              }}
              onClick={() => {
                if (fieldValues.transfersOrPriceBreak.length > 1) updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak'], value: remove(index, 1, fieldValues.transfersOrPriceBreak) });
              }}
            />
            <Icon
              className="tc-icon-add"
              style={{
                marginLeft: '16px',
                lineHeight: '24px',
                verticalAlign: 'middle',
                border: '2px solid green',
                borderRadius: '50%',
                cursor: 'pointer',
              }}
              onClick={() => updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak'], value: insert(index + 1, {}, fieldValues.transfersOrPriceBreak) })}
            />
          </div>))
        }
      />
    </div>
  );
};

export default PrivateToursTransfersPriceBreak;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-forms/non-accommo-rates-form-templates/private-tour-transfers-template.jsx